module.exports = __webpack_public_path__ + "static/img/quote_left.ad0acbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quote_left.png
// module id = e/R2
// module chunks = 0